import React from 'react';
import Box from '../../components/Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import TListItemBaseProps from './@types/TListItemBaseProps';
import TListItemBasicProps from './@types/TListItemBasicProps';

const ListItemBase = ({ as, kind, children, ...rest }: TListItemBasicProps & TListItemBaseProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind,
  });
  return (
    <Box {...conditionalProps} as={as} name="ListItem" {...rest}>
      {children}
    </Box>
  );
};

export default ListItemBase;
